module.exports = __webpack_public_path__ + "static/img/iconchengyuan_24_hei.3db31f08.png";